import { useMutation } from '@tanstack/react-query';
import { apiClient } from 'lib/api';

const logoutFn = async () => {
  return await apiClient.post('api/v1/logout');
};

export function useLogout() {
  return useMutation({
    mutationFn: logoutFn,
  });
}
